import { extend, override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import LogInModal from 'flarum/forum/components/LogInModal';
import SettingsPage from 'flarum/forum/components/SettingsPage';
import LinkButton from 'flarum/common/components/LinkButton';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import User from 'flarum/common/models/User';
import LogInButtons from 'flarum/forum/components/LogInButtons';
import LogInButton from 'flarum/forum/components/LogInButton';
import Model from 'flarum/common/Model';
import { Vnode } from 'mithril';
import UserCard from 'flarum/forum/components/UserCard';
import UserPage from 'flarum/forum/components/UserPage';

app.initializers.add('maicol07/flarum-oidc-client', () => {
  // @ts-ignore
  User.prototype.isConnectedToOpenID = Model.attribute('isConnectedToOpenID');

  function route(id: 'login', append = '') {
    const routes = {
      login: 'auth/oidc',
    };

    return `${app.forum.attribute('baseUrl')}/${routes[id]}${append}`;
  }

  /**
   * Returns a setting added by the extension
   */
  function setting(slug: string, cast?: typeof Boolean | typeof Number): any | boolean | number {
    let setting = app.forum.attribute(`maicol07-oidc-client.${slug}`);

    if (cast !== undefined) {
      if (cast === Boolean && !isNaN(setting as number)) {
        setting = Number(setting);
      }
      return cast(setting);
    }

    return setting;
  }

  extend(HeaderSecondary.prototype, 'items', (items) => {
    if (setting('remove_signup_btn', Boolean)) {
      items.remove('signUp');
    }

    const loginUrl = route('login');

    if (setting('sso_mode', Boolean)) {
      if (!items.has('logIn')) {
        return;
      }

      items.setContent(
        'logIn',
        <a href={loginUrl} className='Button Button--link'>
          {app.translator.trans('core.forum.header.log_in_link')}
        </a>,
      );

      override(LogInModal.prototype, 'oninit', () => {
        window.location.href = loginUrl;
        throw new Error('Stop execution');
      });

      if (!items.has('signUp')) {
        return;
      }

      items.setContent(
        'signUp',
        <a href={loginUrl} className='Button Button--link'>
          {app.translator.trans('core.forum.header.sign_up_link')}
        </a>,
      );

      override(SignUpModal.prototype, 'oninit', () => {
        window.location.href = loginUrl;
        throw new Error('Stop execution');
      });
    } else {
      extend(LogInButtons.prototype, 'items', (items) => {
        items.add('oidcLogin', <LogInButton class='Button Button--block LogInButton LogInButton--oidc' path='/auth/oidc'
                                            icon='fab fa-openid'>
          {app.translator.trans('maicol07-oidc-client.forum.buttons.login', { name: setting('provider_name') })}
        </LogInButton>);
      });
      if (setting('remove_signup_btn', Boolean)) {
        override(LogInModal.prototype, 'footer', (original: () => Vnode) => {
          const footer = original();
          if (footer.children && Array.isArray(footer.children)) {
            footer.children = footer.children.filter(
              (element) => typeof element === 'object' && !Array.isArray(element) && element?.attrs.className !== 'LogInModal-signUp');
          }
          return footer;
        });
      }
    }
  });

  extend(SettingsPage.prototype, 'accountItems', (items) => {
    // @ts-ignore
    if (app.session.user?.isConnectedToOpenID() && items.has('changeEmail')) {
      items.remove('changeEmail');
    }

    // @ts-ignore
    if (app.session.user?.isConnectedToOpenID() && items.has('changePassword')) {
      items.remove('changePassword');
    }

    // @ts-ignore
    if (app.session.user?.isConnectedToOpenID() && setting('manage_account_url', Boolean)) {
      items.add(
        'manageAccount',
        <LinkButton class='Button' icon='fab fa-openid' href={setting('manage_account_url')}
                    target={setting('manage_account_btn_open_in_new_tab') ? '_blank' : ''}>
          {app.translator.trans('maicol07-oidc-client.forum.buttons.manage_account')}
        </LinkButton>,
      );
    }

    if (!setting('sso_mode', Boolean)) {
      items.add(
        'connectOIDC',
        <LinkButton
          icon='fab fa-openid'
          class='Button'
          external={true}
          // @ts-ignore
          href={route('login', `?action=${app.session.user?.isConnectedToOpenID() ? 'disconnect' : 'connect'}`)}
        >
          {app.translator.trans(
            // @ts-ignore
            `maicol07-oidc-client.forum.buttons.${app.session.user?.isConnectedToOpenID() ? 'disconnect_account' : 'connect_account'}`,
            { name: setting('provider_name') },
          )}
        </LinkButton>,
      );
    }
  });

  extend(UserPage.prototype, 'view', (vnode) => {
    if (setting('sync_avatars', Boolean) && Array.isArray(vnode.children) && (vnode.children[0] as Vnode).tag === UserCard) {
      // @ts-expect-error - Vnode doesn't have attrs type
      (vnode.children[0] as Vnode<UserCard>).attrs.editable = false;
    }
  });
});
